export type ContentEditStatusLiveRevision = {
    contentRevisionId: number;
    contentType: string;
    contentRevisionCreationDate: number;
    creationUserId: number;
    creationUserUserName: string;
    creationUserEmail: string;
    creationUserFirstName: string;
    creationUserLastName: string;
}

export type ApiErrorHandler = (
    featureId: string,
    response: any,
    actionKey?: string
) => Generator<any, any, any>;

export enum ContextTypeKeys {
    RESET_QUESTION_ID_AND_SCOREABLE_ITEM_AND_SECTION_ID = 'context/RESET_QUESTION_ID_AND_SCOREABLE_ITEM_AND_SECTION_ID',
    SET_QUESTION_ID_AND_SCORABLE_ITEM_AND_SECTION_ID = 'context/SET_QUESTION_ID_AND_SCORABLE_ITEM_AND_SECTION_ID',
    SET_WORKSPACE_ID = 'context/SET_WORKSPACE_ID',
    SET_ITEM_BANK_ID = 'context/SET_ITEM_BANK_ID',
    SET_CONTENT_ITEMS = 'context/SET_CONTENT_ITEMS',
    SET_CONTENT_ITEM_IDS = 'context/SET_CONTENT_ITEM_IDS',
    SET_CURRENT_ITEM_CONTEXT = 'context/SET_CURRENT_ITEM_CONTEXT',
    SET_TEMPLATE_IN_CURRENT_ITEM_CONTEXT = 'context/SET_TEMPLATE_IN_CURRENT_ITEM_CONTEXT',
    SET_CURRENT_ITEM_CONTEXT_DIRTY = 'context/SET_CURRENT_ITEM_CONTEXT_DIRTY',
    SET_CURRENT_ITEM_CONTEXT_LOCK = 'context/SET_CURRENT_ITEM_CONTEXT_LOCK',
    SET_CURRENT_QTI_CONTEXT_ITEM = 'context/SET_CURRENT_QTI_CONTEXT_ITEM',
    SET_CONTEXT_EDIT_STATUS = 'context/SET_CONTEXT_EDIT_STATUS',
    SET_CURRENT_RESOURCE_CONTEXT_ITEM = 'context/SET_CURRENT_RESOURCE_CONTEXT_ITEM',
    RESET_CONTEXT_EDIT_STATUS = 'context/RESET_CONTEXT_EDIT_STATUS',
    SHOW_CONTEXT_LOCK_MODAL = 'context/SHOW_CONTEXT_LOCK_MODAL',
    CLOSE_CONTEXT_LOCK_MODAL = 'context/CLOSE_CONTEXT_LOCK_MODAL',
    SET_ITEM_BANK_INFO = 'context/SET_ITEM_BANK_INFO',
    SET_CONTEXT_ITEM_BANK_INFO = 'context/SET_CONTEXT_ITEM_BANK_INFO',
    SETUP_WORKSPACES = 'context/SETUP_WORKSPACES',
    WORKSPACE_ID_UPDATED = 'context/WORKSPACE_ID_UPDATED',
    UPDATE_CURRENT_ITEM_CONTEXT = 'context/UPDATE_CURRENT_ITEM_CONTEXT',
    UPDATE_CURRENT_QTI_CONTEXT_ITEM = 'context/UPDATE_CURRENT_QTI_CONTEXT_ITEM',
    TOGGLE_NAVIGATION_LOCK = 'context/TOGGLE_NAVIGATION_LOCK',
    TOGGLE_PROPERTIES_PANEL = 'context/TOGGLE_PROPERTIES_PANEL',
    UNLOCK_CONTEXT = 'context/UNLOCK_CONTEXT',
    RESTORE_CURRENT_QTI_CONTEXT_ITEM = 'context/RESTORE_CURRENT_QTI_CONTEXT_ITEM',
    CONTEXT_RENAME = 'context/CONTEXT_RENAME',
    SET_IS_XTM_DATA_FETCHED = 'context/SET_IS_XTM_DATA_FETCHED',
    SET_IS_IB_TEMPLATE = 'context/SET_IS_IB_TEMPLATE',
    SET_CURRENT_QTI_CONTEXT_ITEM_META_DATA = 'context/SET_CURRENT_QTI_CONTEXT_ITEM_META_DATA',
    SET_DYNAMIC_ANSWER_KEY_EVENT = 'context/SET_DYNAMIC_ANSWER_KEY_EVENT',
    SET_IS_QTI_CONTEXT_LOCKED = 'context/SET_IS_QTI_CONTEXT_LOCKED',
    FETCH_ADDITIONAL_CONTEXT_ITEM_DATA = 'context/FETCH_ADDITIONAL_CONTEXT_ITEM_DATA',
    FETCH_CONTEXT_ITEM_BANK_INFO = 'context/FETCH_CONTEXT_ITEM_BANK_INFO',
    SET_CONTEXT_QTI_ITEM_PUBLISH_STATUS = 'context/SET_CONTEXT_QTI_ITEM_PUBLISH_STATUS',
    SET_CONTEXT_QTI_ITEM_BANK_ID = 'context/SET_CONTEXT_QTI_ITEM_BANK_ID',
    SET_ITEM_BANK_FORBIDDEN = 'context/SET_ITEM_BANK_FORBIDDEN',
    SET_MAX_ANSWERS_WARNING = 'context/SET_MAX_ANSWERS_WARNING',
    GET_ASSESSMENT = 'context/GET_ASSESSMENT',
    GET_ASSESSMENT_SUCCESS = 'context/GET_ASSESSMENT_SUCCESS',
    UPDATE_ASSESSMENT = 'context/UPDATE_ASSESSMENT',
    UPDATE_ASSESSMENT_SUCCESS = 'context/UPDATE_ASSESSMENT_SUCCESS',
    BULK_UPDATE_ASSESSMENT = 'context/BULK_UPDATE_ASSESSMENT',
    SHOW_BULK_UPDATE_SUCCESS_NOTIFICATION = 'context/SHOW_BULK_UPDATE_SUCCESS_NOTIFICATION',
    VIEW_TYPE = "context/VIEW_TYPE",
    GET_ASSESSMENT_DETAILS = 'context/GET_ASSESSMENT_DETAILS',
    GET_ASSESSMENT_DETAILS_SUCCESS = 'context/GET_ASSESSMENT_DETAILS_SUCCESS',
    ADD_CONTENT_BLOCK_SELECTION = 'context/ADD_CONTENT_BLOCK_SELECTION',
    SET_ACTIVE_LANGUAGE = 'context/SET_ACTIVE_LANGUAGE',
    ADD_CONTENT_BLOCK_SELECTION_SUCCESS = 'context/ADD_CONTENT_BLOCK_SELECTION_SUCCESS',
    CLEAR_BULK_UPDATE_SUCCESS_NOTIFICATION = 'context/CLEAR_BULK_UPDATE_SUCCESS_NOTIFICATION',
    RUBRIC_SAVED_TO_QUESTION = 'context/RUBRIC_SAVED_TO_QUESTION',
    CLOSE_EDIT_RUBRIC_OVERLAY = 'context/CLOSE_EDIT_RUBRIC_OVERLAY',
    SET_QUESTION_SUPPORTED_LANGUAGES = 'context/SET_QUESTION_SUPPORTED_LANGUAGES',
    SET_QUESTION_SET_SUPPORTED_LANGUAGES = 'context/SET_QUESTION_SET_SUPPORTED_LANGUAGES',
    SET_ACTIVE_CONTENT_LANGUAGE = 'context/SET_ACTIVE_CONTENT_LANGUAGE',
    SUPPORTED_LANGUAGES_SAVED = 'context/SUPPORTED_LANGUAGES_SAVED',
    QUESTION_LANGUAGE_UPDATE_COMPLETE = 'context/QUESTION_LANGUAGE_UPDATE_COMPLETE',
    SET_CURRENT_QTC_SECTION_DATA = 'context/SET_CURRENT_QTC_SECTION_DATA',
}

export type ContextUrlSearchStringObject = {
    contentItemIds: number[] | number;
    contentType: string;
    contextId: number;
    workspaceId: string;
    questionId: number;
    itemBankId: number;
    scorableItem: number;
    sectionId: number;
    qtiContextItemId: number;
    scorableItemContextId: number;
    resourceContextItemId: number;
    contentTemplate: string;

    [key: string]: any;
}

export type QTIBranchRule = {
    isFallback: boolean;
    minValue: number;
    target: string;
}

export type QTISectionLayout = {
    allowStimulusResizing: boolean;
    layout: string;
    stimulusSize: number;
}

export type QTISectionSelection = {
    option: string;
    selected: number;
}

export type QTIElementType = 'questionRef' | 'sectionRef' | 'inlineSection';

export type QTIVersion = '2.1' | '2.2';

export type QTIContextNumbering = {
    countingNumberingItem: boolean;
    questionNumberInQuestionSet?: number;
    questionNumberingInSection?: string;
    scorableItemsRange?: string;
    sectionNumber: number;
    subQuestionNumber?: string;
}

export type TemplateReference = {
    title: string;
    contentItemId: number;
    contentRevisionId: number;
}

export type PresetsConfig = {
    needStyles?: boolean;
    needSymbols?: boolean;
}

export type QTIContextItem = {
    branchRules?: QTIBranchRule;
    category?: string;
    contentRevisionId?: number;
    contextId: number; // the contentItemId of the section or question set that has this item in its structure
    creationDate: string;
    creationUserId: number;
    creationUserName: string;
    contentType?: string;
    customFields?: any[];
    defaultLanguage?: string;
    fixed?: boolean;
    lastModified: string;
    logicalName: string;
    marketplaceId: number;
    maxScore: number;
    modifyingUserId: number;
    modifyingUserName: string;
    numbering: QTIContextNumbering;
    objectId: number; // the id of the item. This can be the id of a inline section or a contentRevision of a question.
    objectType: string; // content_qti_section / content_question_qti2_*
    orderNumber: number; // the contentItemId of the section or question set that has this item in its structure
    parentId: number; // if a question, it will be the section holding it, if a section the question set when that is the context
    publishStatus?: string;
    contextPublishStatus?: string;
    parentQtiElementType: string;
    qtiElementType: QTIElementType;
    sectionLayout?: QTISectionLayout;
    sectionSelection?: QTISectionSelection;
    supportedLanguages?: string[];
    title: string;
    version?: QTIVersion;
    weight?: number;
    templateReference?: TemplateReference;
    isTrashed: boolean;
    contextContentType?: string;
    labels?: string;
    itemBankId?: number;
    itemBankInfo?: ItemBankInfo;
    isTemplate?: boolean;
}


/* eslint-disable-line @typescript-eslint/camelcase */
export enum AdditionalResourceTypes {
    RESOURCE_AUDIO = 'audio',
    RESOURCE_FILE = 'file',
    RESOURCE_LINK = 'link',
    RESOURCE_AUDIO_SCRIPT = 'audio_script',
    STIMULUS = 'stimulus',
    PCI_TOOL = 'pci_tool',
}

export const navigableResourceType = [
    AdditionalResourceTypes.RESOURCE_AUDIO,
    AdditionalResourceTypes.RESOURCE_AUDIO_SCRIPT,
    AdditionalResourceTypes.STIMULUS,
    AdditionalResourceTypes.RESOURCE_FILE,
    AdditionalResourceTypes.RESOURCE_LINK,
    AdditionalResourceTypes.PCI_TOOL,
];

export const removableResourceType = [
    AdditionalResourceTypes.RESOURCE_AUDIO,
    AdditionalResourceTypes.RESOURCE_FILE,
    AdditionalResourceTypes.RESOURCE_AUDIO_SCRIPT,
    AdditionalResourceTypes.RESOURCE_LINK,
    AdditionalResourceTypes.PCI_TOOL,
];

export type AdditionalResourceType =
    AdditionalResourceTypes.RESOURCE_AUDIO |
    AdditionalResourceTypes.RESOURCE_FILE |
    AdditionalResourceTypes.RESOURCE_LINK |
    AdditionalResourceTypes.RESOURCE_AUDIO_SCRIPT |
    AdditionalResourceTypes.STIMULUS |
    AdditionalResourceTypes.PCI_TOOL;

export type AdditionalResource = {
    contentItemId?: number;
    creationDate?: number;
    creationUserFirstName?: string;
    creationUserId?: number;
    creationUserLastName?: string;
    fileSize?: number;
    link?: string;
    linkMatch?: string;
    mimeType?: string;
    sourceFileName?: string;
    title: string;
    textContent?: string;
    type: AdditionalResourceType;
    contentRevisionId?: number;
}

export type AssessmentRunContext = {
    assessmentRunId: number;
    assessmentRunTitle: string;
}

export type SectionLayout = {
    layout: string;
}

export type DateableObject = {
    itemValueId: number;
    valueText?: string;
}

export type ItemContext = {
    additionalResources?: AdditionalResource[];
    assessmentRunContexts: AssessmentRunContext[];
    contentType: string;
    contextId: number;
    contentBlockIdGenerationType?: string;
    creationDate: string;
    creationUserId: number;
    creationUserName: string;
    customFields: any[]; // TODO set proper type
    isDeleted: boolean;
    isTrashed: boolean;
    itemBankId?: number;
    isTemplate?: boolean;
    itemType: string; // TODO set proper type ('STRUCTURE' | 'SECTION' | 'etc')
    labels?: string[];
    lastModified: string;
    lifeCycleStatus?: string;
    dateable?: DateableObject;
    linkedTaxonomy: any[]; // TODO set proper type
    liveContentRevisionId: number;
    logicalName: string;
    marketplaceId: number;
    maxScore?: number;
    modifyingUserId: number;
    modifyingUserName: string;
    numberOfRevisions: number;
    numberOfScorableItems: number;
    numberOfQuestionsInStructure: number;
    numberOfSharedWithOrgs: number;
    numberOfSharedWithUsers: number;
    numberingScheme: string; // TODO set proper type ('testSequential' | 'etc')
    objectId: number;
    objectType: string;
    permissions: any[]; // TODO set proper type
    publishStatus?: string;
    contextPublishStatus?: string;
    sectionLayout?: SectionLayout;
    supportedLanguages?: string[];
    title: string;
    contextContentType?: string;
    customPermissions? : CustomPermissions[];
    defaultLanguage?: string;
    securityInherit?: boolean;
}

export type ContentEditLockUserInfo = {
    lockDate: string;
    lockingUserEmail: string;
    lockingUserFirstName: string;
    lockingUserLastName: string;
    lockingUserUserId: string;
    lockingUserUsername: string;
    timeout: string;
}
export type ContentEditStatus = {
    isReadOnlyContent: boolean;
    isReadOnlyMetadata: boolean;
    liveRevision: ContentEditStatusLiveRevision;
    lockInfo?: ContentEditLockUserInfo[];
    reasonOfReadOnly?: ContentReadOnlyReason;
    templateRevision?: TemplatecontentEditStatus;
}

export type ContentStatus = {
    contentStatus: string;
    lifeCycleStatus: string;
    lockEditContent: boolean;
    lockEditMetadata: boolean;
}

export type TemplatecontentEditStatus = {
    contentItemId: number;
    contentRevisionCreationDate: number;
    contentType: string;
    creationUserEmail: string;
    creationUserFirstName: string;
    creationUserLastName: string;
    creationUserUserName: string;
    currentContentRevisionId: number;
    contentRevisionId: number;
    isCurrentMappedTemplateRevisionLive: boolean;
    liveContentRevisionId: number;
    creationUserId: number;
}

export enum ContentReadOnlyReasons {
    IS_LOCKED_PUBLISH_STATUS = 'is-locked-by-publishStatus',
    IS_NOT_LIVE_REVISION = 'is-not-live',
    IS_BEING_EDITED_BY_SOMEONE_ELSE = 'is-locked-by-someone-else',
    IS_NOT_TEMPLATE_LIVE_REVISION = 'template-is-not-live',
    IS_NOT_QUESTION_LIVE_REVISION = 'question-is-not-live',
    IS_NOT_TEMPLATE_CONTENT_IN_TEMPLATE_CONTEXT = 'is-non-template-content-in-template-context'
}

export type ContentReadOnlyReason =
    ContentReadOnlyReasons.IS_LOCKED_PUBLISH_STATUS |
    ContentReadOnlyReasons.IS_NOT_LIVE_REVISION |
    ContentReadOnlyReasons.IS_BEING_EDITED_BY_SOMEONE_ELSE |
    ContentReadOnlyReasons.IS_NOT_TEMPLATE_LIVE_REVISION |
    ContentReadOnlyReasons.IS_NOT_QUESTION_LIVE_REVISION |
    ContentReadOnlyReasons.IS_NOT_TEMPLATE_CONTENT_IN_TEMPLATE_CONTEXT;

export type OrgUnit = {
    orgUnitId: number;
    orgUnitName: string;
    numberOfOrgUnitMembers?: number;
    customUserRoles?: Record<string, string>;
}

export type CustomUserContributorRole = {
    [key: number]: string;
}

export type ItemBankInfo = {
    api?: string;
    itemBankId?: number;
    itemBankName: string;
    itemBankPrefix?: string;
    itemBankColor?: string;
    itemBankPresetConfigurationId?: number;
    itemBankPresetConfigurationContent?: string;
    itemBankPresetStatusTransitionId?: number;
    itemBankPresetStatusTransitionContent?: string;
    statuses: ContentStatus[];
    itemBankOrgUnits?: OrgUnit[];
    success?: true;
    customUserRoles?: CustomUserContributorRole[];
}

export type CustomPermissions = {
    customUserRoleId?: number;
    granteeIds: number[];
}


export type ContextItem = ItemContext | QTIContextItem;

export type SectionDetailFieldType = 'ref' | 'name' | 'type' | 'value';

export type SectionDetalFieldResponseType = string | number | boolean | any[] | SectionLayout | string[] | QTISectionLayout | [string];

export type AlternativesLimitErrorMsg = {
    title: string;
    maxChoicesVal: number;
    firstLineText: string;
    secondLineText: string;
    buttonCaption: string;
} | undefined;
